// AZ Reserve Mining Participation Program — review-environment controls.
// This page is a short-term, password-protected stakeholder review page.
// To make the page PUBLIC later, simply flip these flags (no rebuild needed):
//   - gateEnabled: false  -> removes the password gate
//   - noindex: false      -> allows search engine indexing
// (Also remember to remove the Disallow line in /public/robots.txt when going public.)

export const MINING_PROGRAM = {
  // Master switch for the client-side password gate.
  gateEnabled: true,
  // Shared review password (client-side gate — keeps the page unlisted, not a secure secret store).
  password: 'Staking123',
  // Emit <meta name="robots" content="noindex,nofollow,noarchive"> while under review.
  noindex: true,
  // Route path (kept here so it is easy to find / change).
  routePath: '/Mining-participation-program',
};
